import { useState } from "react";
import { MailWarning, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const VerifyBanner = () => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      setSent(true);
      toast.success(`Verification link sent to ${user.email}`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="verify-email-banner"
      className="flex flex-wrap items-center gap-3 px-4 sm:px-8 py-2.5 bg-amber-500/[0.09] border-b border-amber-500/25"
    >
      <MailWarning className="w-4 h-4 text-amber-400 shrink-0" />
      <p className="text-[13px] text-amber-200/90 min-w-0">
        Confirm <span className="font-medium text-amber-100">{user.email}</span> to start creating proposals.
        We sent you a link.
      </p>
      <button
        data-testid="verify-email-resend-btn"
        onClick={resend}
        disabled={busy || sent}
        className="ml-auto text-[12px] font-medium text-amber-300 hover:text-amber-200 border border-amber-500/40 rounded-md px-2.5 py-1 disabled:opacity-50 flex items-center gap-1.5 transition-colors"
      >
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : sent ? <Check className="w-3 h-3" /> : null}
        {sent ? "Link sent" : "Resend verification"}
      </button>
    </div>
  );
};
